// extracted by mini-css-extract-plugin
module.exports = {"container":"sticky-block_container__aPiLI","item":"sticky-block_item__1N_Ta"};